@if (isNewAddressSearchEnabled()) {
  <mwe-address-search
    [predefinedOlavKey]="predefinedOlavKey()"
    [ignoreAvailableZipCodes]="ignoreAvailableZipCodes()"
    [selectedOlav]="selectedOlav()"
    [processType]="processType()"
    (selectedOlavChange)="onSelectOlav($event)"
    (addressInputCompleted)="onValidAddressSet($event)"
    (showErrorChange)="onErrorState($event)"
    (noResultsFound)="noResultsFound.emit(true)"
  />
} @else {
  <mwe-address-input
    [predefinedOlavKey]="predefinedOlavKey()"
    [ignoreAvailableZipCodes]="ignoreAvailableZipCodes()"
    [selectedAddress]="selectedOlav()"
    [processType]="processType()"
    (selectedOlavEvent)="onSelectOlav($event)"
    (selectionFinishedEvent)="onValidAddressSet($event)"
    (allSearchParametersEntered)="onValidAddressSet($event)"
    (errorStateEvent)="onErrorState($event)"
    noResultsButtonText="shared.international-address-input.noResultsButtonText"
    (noResultsButtonClicked)="noResultsFound.emit(true)"
  />
}
